module.exports = window.require("dojo/mouse");